<template>
	<div
		class="hh-modal modal fade"
		data-backdrop="static"
		tabindex="-1"
	>
		<div
			class="modal-dialog modal-dialog-centered"
			:class="{ 'modal-lg': size == 'lg' }"
		>
			<div class="modal-content">
				<div
					class="modal-header p-2"
					v-if="title"
				>
					<h4 class="font-weight-bold mb-0 modal-title text-center w-100">{{ title }}</h4>
				</div>
				<simplebar class="modal-body py-5" data-simplebar-auto-hide="false">
					<slot />
				</simplebar>
				<div
					class="modal-footer justify-content-around"
					v-if="$slots.footer"
				>
					<slot name="footer"></slot>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ["title", "size"]
};
</script>

<style lang="scss">
@import '~simplebar/dist/simplebar.min.css';
@import "@/scss/variables.scss";

.hh-modal {

	a {
		color: $red;
		font-weight: bold;
	}

	.modal-content {
		background-image: url("../assets/wood_pattern.png");
	}

	.modal-body {
		max-height: 75vmin;
		//overflow-y: auto;
	}

	.simplebar-scrollbar::before {
		background-color: $dark;
	}
}
</style>